import { useFormikContext } from 'formik'
import { ReactElement } from 'react'
import { defineMessages, FormattedMessage, useIntl } from 'react-intl'

import { Column } from 'components/v2/Column'
import { Row } from 'components/v2/Row'
import { Select } from 'components/v2/Select'
import { GTDeactivateVehicleReasonInput } from 'gql/types.generated'
import { IChangeVehicleStatusForm } from 'features/Vehicles/types'
import { safeFormatMessage } from 'utils/intl'

const messages = defineMessages({
  reasonPlaceholder: {
    id: 'vehicle.deactivate.reason.placeholder',
    defaultMessage: 'Select a reason'
  }
})

const DEACTIVATE_VEHICLE_REASONS = [GTDeactivateVehicleReasonInput.Operational]

const deactivateVehicleReasonsMessages = defineMessages({
  [GTDeactivateVehicleReasonInput.Operational]: {
    id: 'vehicle.deactivate.reason.operational',
    defaultMessage: 'Operational'
  }
})

export const DeactivateInputs = (): ReactElement => {
  const intl = useIntl()
  const { values, handleChange, handleBlur, touched, errors } = useFormikContext<IChangeVehicleStatusForm>()

  return (
    <Row>
      <Column>
        <Select
          id="reason"
          value={values.reason}
          onChange={handleChange}
          onBlur={handleBlur}
          touched={touched.reason}
          errors={errors.reason}
          label={<FormattedMessage id="vehicle.deactivate.reason.label" defaultMessage="Reason" />}
        >
          <option value="">{intl.formatMessage(messages.reasonPlaceholder)}</option>
          {DEACTIVATE_VEHICLE_REASONS.map((reason): ReactElement => {
            return (
              <option key={reason} value={reason}>
                {safeFormatMessage({ intl, messages: deactivateVehicleReasonsMessages, key: reason })}
              </option>
            )
          })}
        </Select>
      </Column>
    </Row>
  )
}
